import { render } from "./inJobWorkerIds.vue?vue&type=template&id=a53e2834"
import script from "./inJobWorkerIds.vue?vue&type=script&lang=js"
export * from "./inJobWorkerIds.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__